<div #contentContainer [innerHTML]="safeHtml"></div>
